import { render, staticRenderFns } from "./QuickLabelPartner.vue?vue&type=template&id=97e6d8ae&scoped=true&"
import script from "./QuickLabelPartner.vue?vue&type=script&lang=js&"
export * from "./QuickLabelPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e6d8ae",
  null
  
)

export default component.exports